import { render, staticRenderFns } from "./CourseAssigner.vue?vue&type=template&id=21413af0&"
import script from "./CourseAssigner.vue?vue&type=script&lang=js&"
export * from "./CourseAssigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports